import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { max } from 'moment';
import { SelectItem } from 'primeng';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserAction } from 'src/app/enum/user/userActions';
import { AccessUserInfo, labRangeAlertRule, UserDetail } from 'src/app/models';
import { LabManagerService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'bart-lab-range-assign',
  templateUrl: './lab-range-assign.component.html',
  styleUrls: ['./lab-range-assign.component.scss'],
})
export class LabRangeAssignComponent implements OnInit {
  public userInfo: UserDetail;
  labRangeAssignForm: FormGroup;
  labRangeAlertdataByTest: any[] = []
  labRangeAlertdata:labRangeAlertRule;
  labTestMasterID: number;
  labOperandList:SelectItem[]=[]
  acceptableOperandList:SelectItem[]=[]
  actionLBOperandList:SelectItem[]=[]
  actionUBOperandList:SelectItem[]=[]
  unAcceptableOperandList:SelectItem[]=[]

  constructor(private formBuilder: FormBuilder, private _dynamicDialogRef: DynamicDialogRef, public dialogConfig: DynamicDialogConfig, private _loaderService: LoaderService,
    private _labManagerService: LabManagerService,private _userService: UserService) { 
      
    }

  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.labRangeAssignForm = this.formBuilder.group(
      {
        acceptableInputNumber: [null, Validators.required],
        acceptableDropdown: [null],
        acceptableCheckBox: [false],
        acceptableInstruction: [''],
        actionLowerBoundaryInputNumber: [null, Validators.required],
        actionLowerBoundaryDropdown: [null],
        actionUpperBoundaryInputNumber: [null, Validators.required],
        actionUpperBoundaryDropdown: [null],
        actionLevelCheckBox: [false],
        actionLevelInstruction: [''],
        unAcceptableInputNumber: [null, Validators.required],
        unAcceptableDropdown: [null],
        unAcceptableCheckBox: [false],
        unAcceptableInstruction: [''],
        
      });
    this.labRangeAlertdata = this.dialogConfig.data.labRangeAlertdata
    this.labOperandList=this.dialogConfig.data.labOperands;
    if (this.labRangeAlertdata) {
      this.getLabRangeAlertRuleByTest(this.labRangeAlertdata.LabTestMasterID)
    }
    this.acceptableOperandList = Object.assign([], this.labOperandList)
    this.actionLBOperandList = Object.assign([], this.labOperandList)
    this.actionUBOperandList = Object.assign([], this.labOperandList)
    this.unAcceptableOperandList = Object.assign([], this.labOperandList)
    //#region assign default value for operator dropdowns
    if(this.labOperandList)
      {
        this.updateControlValueAndValidity("acceptableDropdown",this.labOperandList[0])
        this.updateControlValueAndValidity("actionLowerBoundaryDropdown",this.labOperandList[0])
        this.updateControlValueAndValidity("actionUpperBoundaryDropdown",this.labOperandList[0])
        this.updateControlValueAndValidity("unAcceptableDropdown",this.labOperandList[0])
      }
    //#endregion
    

    this.labRangeAssignForm.get("acceptableCheckBox").valueChanges.subscribe(x => {
      if (x) {
        this.labRangeAssignForm.get('acceptableInputNumber').patchValue(null);
        this.acceptableOperandList = null;
        this.updateControlValueAndValidity("acceptableDropdown",null)
        this.labRangeAssignForm.get('acceptableInputNumber').setValidators(null)
      }
      else {
        this.acceptableOperandList = Object.assign([], this.labOperandList)
        this.updateControlValueAndValidity("acceptableDropdown",this.acceptableOperandList[0])
        this.labRangeAssignForm.get('acceptableInputNumber').setValidators([Validators.required]);
      }
      this.labRangeAssignForm.get('acceptableInputNumber').updateValueAndValidity();
    })
    this.labRangeAssignForm.get("actionLevelCheckBox").valueChanges.subscribe(x => {
      if (x) {
        this.labRangeAssignForm.get('actionLowerBoundaryInputNumber').patchValue(null);
        this.labRangeAssignForm.get('actionUpperBoundaryInputNumber').patchValue(null);
        this.labRangeAssignForm.get('actionUpperBoundaryInputNumber').setValidators(null)
        this.labRangeAssignForm.get('actionLowerBoundaryInputNumber').setValidators(null);
        this.actionLBOperandList = null
        this.actionUBOperandList = null
        this.updateControlValueAndValidity("actionLowerBoundaryDropdown",null)
        this.updateControlValueAndValidity("actionUpperBoundaryDropdown",null)
        
      }
      else {
        this.labRangeAssignForm.get('actionUpperBoundaryInputNumber').setValidators([Validators.required]);
        this.labRangeAssignForm.get('actionLowerBoundaryInputNumber').setValidators([Validators.required]);
        this.actionLBOperandList = Object.assign([], this.labOperandList)
        this.actionUBOperandList = Object.assign([], this.labOperandList)
        this.updateControlValueAndValidity("actionLowerBoundaryDropdown",this.actionLBOperandList[0])
        this.updateControlValueAndValidity("actionUpperBoundaryDropdown",this.actionUBOperandList[0])

      }
      this.labRangeAssignForm.get('actionUpperBoundaryInputNumber').updateValueAndValidity();
      this.labRangeAssignForm.get('actionLowerBoundaryInputNumber').updateValueAndValidity();
    })
    this.labRangeAssignForm.get("unAcceptableCheckBox").valueChanges.subscribe(x => {
      if(x){
        this.labRangeAssignForm.get('unAcceptableInputNumber').patchValue(null);
        this.labRangeAssignForm.get('unAcceptableInputNumber').setValidators(null);
        this.unAcceptableOperandList = null
        this.updateControlValueAndValidity("unAcceptableDropdown",null)
      }
    else{
        this.labRangeAssignForm.get('unAcceptableInputNumber').setValidators([Validators.required]);
        this.unAcceptableOperandList = Object.assign([], this.labOperandList)
        this.updateControlValueAndValidity("unAcceptableDropdown",this.unAcceptableOperandList[0])
     }
     this.labRangeAssignForm.get('unAcceptableInputNumber').updateValueAndValidity();
    })
//
  }

  public checkValidity(): void {
    Object.keys(this.labRangeAssignForm.controls).forEach((key) => {
      this.labRangeAssignForm.controls[key].markAsDirty();
    });
  }
  saveLabRangeAssign() {  
    this.checkValidity();
    if (this.labRangeAssignForm.valid) {
      this.updateLabRangeAlertRule()
    }
    else {
    }
    //#region User Action Audit
    this._userService.logUserAction({
      userName:this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.LAB_MANAGER,
      screenPath:location.pathname,
      key:'LabTestMasterID',
      value:this.labRangeAlertdata.LabTestMasterID,
      eventDescription:this.dialogConfig.header=="Assign Range"?UserActionDescription.ASSIGN_RANGE_POPUP_SAVE_CLICKED:UserActionDescription.EDIT_RANGE_POPUP_SAVE_CLICKED


    }); 
  }
  closePopup() {
    this._dynamicDialogRef.destroy();
    //#region User Action Audit
    this._userService.logUserAction({
      userName:this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.LAB_MANAGER,
      screenPath:location.pathname,
      key:'LabTestMasterID',
      value:this.labRangeAlertdata.LabTestMasterID,
      eventDescription:this.dialogConfig.header=="Assign Range"?UserActionDescription.ASSIGN_RANGE_POPUP_CANCEL_CLICKED:UserActionDescription.EDIT_RANGE_POPUP_CANCEL_CLICKED

    }); 
  //#endregion
  }
  getLabRangeAlertRuleByTest(labTestMasterID: number) {
    this._loaderService.show();
    let labRangeAlertRuleByTest = {
      "GETLABRANGEALERTRULEBYTEST": {
        labTestMasterID: labTestMasterID
      }
    }
    this._labManagerService.getLabRangeAlertRuleByTest(labRangeAlertRuleByTest).subscribe(response => {
      if (response) {
        this.labRangeAlertdataByTest = response.getLabRangeAlertRuleByTest;
        if(this.labRangeAlertdataByTest.length>0){ 
          this.dialogConfig.header="Edit Range"
          this.labRangeAssignForm.patchValue({
            acceptableInputNumber: this.labRangeAlertdataByTest[0].AcceptableLevel,
            acceptableCheckBox:this.labRangeAlertdataByTest[0].IsAcceptableCheck,
            acceptableInstruction: this.labRangeAlertdataByTest[0].AcceptableInstructions==null?null:this.labRangeAlertdataByTest[0].AcceptableInstructions.toString().trim(),
            actionLowerBoundaryInputNumber: this.labRangeAlertdataByTest[0].ActionLB,
            actionUpperBoundaryInputNumber: this.labRangeAlertdataByTest[0].ActionUB,
            actionLevelCheckBox:this.labRangeAlertdataByTest[0].IsActionCheck,
            actionLevelInstruction: this.labRangeAlertdataByTest[0].ActionInstructions==null?null:this.labRangeAlertdataByTest[0].ActionInstructions.toString().trim(),
            unAcceptableInputNumber: this.labRangeAlertdataByTest[0].UnacceptableLevel,
            unAcceptableCheckBox: this.labRangeAlertdataByTest[0].IsUnacceptableCheck,
            unAcceptableInstruction: this.labRangeAlertdataByTest[0].UnacceptableInstructions==null?null:this.labRangeAlertdataByTest[0].UnacceptableInstructions.toString().trim(),
            acceptableDropdown: this.labOperandList.find(x=>x.value==this.labRangeAlertdataByTest[0].AcceptableOperator),
            actionLowerBoundaryDropdown: this.labOperandList.find(x=>x.value==this.labRangeAlertdataByTest[0].ActionLowerOperator),
            actionUpperBoundaryDropdown: this.labOperandList.find(x=>x.value==this.labRangeAlertdataByTest[0].ActionHigherOperator),
            unAcceptableDropdown: this.labOperandList.find(x=>x.value==this.labRangeAlertdataByTest[0].UnacceptableOperator)
            })
        }
        this._loaderService.hide()
      //#region User Action Audit
        this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.BUTTON_CLICKED,
        screenName: ScreenName.LAB_MANAGER,
        screenPath: location.pathname,
        key: "LabTestMasterID",
        value: labTestMasterID,
        eventDescription:this.dialogConfig.header=="Assign Range"?UserActionDescription.LAB_RANGE_ALERTS_EDIT_ICON_CLICKED_ASSIGN_RANGE_OPENED:UserActionDescription.LAB_RANGE_ALERTS_EDIT_ICON_CLICKED_EDIT_RANGE_OPENED
      });
      //#endregion

      }
      else {
        this._loaderService.hide()
      }
    },
      (error) => {
        this._loaderService.hide()
      });

  }
  updateLabRangeAlertRule() {
    this._loaderService.show();
    let updateLabRangeAlertRule = {
      "UPDATELABRANGEALERTRULE": {
        UserName: this.userInfo.userName,
        labTestMasterID:this.labRangeAlertdata.LabTestMasterID,
        AcceptableLevel: this.labRangeAssignForm.get('acceptableInputNumber').value,
        IsAcceptableCheck: this.labRangeAssignForm.get('acceptableCheckBox').value,
        AcceptableInstructions: this.labRangeAssignForm.get('acceptableInstruction').value,
        ActionLB: this.labRangeAssignForm.get('actionLowerBoundaryInputNumber').value,
        ActionUB: this.labRangeAssignForm.get('actionUpperBoundaryInputNumber').value,
        IsActionCheck: this.labRangeAssignForm.get('actionLevelCheckBox').value,
        ActionInstructions: this.labRangeAssignForm.get('actionLevelInstruction').value,
        UnacceptableLevel: this.labRangeAssignForm.get('unAcceptableInputNumber').value,
        IsUnacceptableCheck: this.labRangeAssignForm.get('unAcceptableCheckBox').value,
        UnacceptableInstructions: this.labRangeAssignForm.get('unAcceptableInstruction').value,
        AcceptableOperator:this.acceptableOperandList?this.labRangeAssignForm.get('acceptableDropdown').value.value:null,
        ActionLowerOperator:this.actionLBOperandList?this.labRangeAssignForm.get('actionLowerBoundaryDropdown').value.value:null,
        ActionHigherOperator:this.actionUBOperandList?this.labRangeAssignForm.get('actionUpperBoundaryDropdown').value.value:null,
        UnacceptableOperator:this.unAcceptableOperandList?this.labRangeAssignForm.get('unAcceptableDropdown').value.value:null
     
      }
    }
    this._labManagerService.updateLabRangeAlertRule(updateLabRangeAlertRule).subscribe(response => {
      this._loaderService.hide()
      this.dialogConfig.data.labRangeAlertdata.AcceptableLevel=this.labRangeAssignForm.get('acceptableCheckBox').value==false?this.labRangeAssignForm.get('acceptableDropdown').value.value+' '+this.labRangeAssignForm.get('acceptableInputNumber').value:'Does not apply';
      this.dialogConfig.data.labRangeAlertdata.ActionLevel=this.labRangeAssignForm.get('actionLevelCheckBox').value==false?this.labRangeAssignForm.get('actionLowerBoundaryDropdown').value.value+' '+this.labRangeAssignForm.get('actionLowerBoundaryInputNumber').value+' , '+this.labRangeAssignForm.get('actionUpperBoundaryDropdown').value.value+' '+this.labRangeAssignForm.get('actionUpperBoundaryInputNumber').value:'Does not apply';
      this.dialogConfig.data.labRangeAlertdata.UnacceptableLevel=this.labRangeAssignForm.get('unAcceptableCheckBox').value==false?this.labRangeAssignForm.get('unAcceptableDropdown').value.value+' '+this.labRangeAssignForm.get('unAcceptableInputNumber').value:'Does not apply';
      this._dynamicDialogRef.destroy();
    },
      (error) => {
        this._loaderService.hide()
      });
  }
  decimalFilter(event: any) {
    const reg = /^-?\d*(\.\d{0,18})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);
    if (!reg.test(input)) {
        event.preventDefault();
    }
 }
  updateControlValueAndValidity(ddlControlName:string,ddlValue:any)
  {
    try{
    this.labRangeAssignForm.get(ddlControlName).patchValue(ddlValue);
    this.labRangeAssignForm.get(ddlControlName).updateValueAndValidity();
    }catch(ex){ }
  }
}
